import Vue from 'vue'
// @ts-ignore
import App from './App.vue'
// @ts-ignore
import router from './router'
// @ts-ignore
import store from './store'
import '../public/js/flexible'
// @ts-ignore
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
// 我们在main.js中用常量创建一个bus，然后将它放入Vue实例的原型对象中。
const icons = new Vue()
const floors = new Vue()
Vue.prototype.$icos = icons;
Vue.prototype.$floors = floors;
 window.addEventListener('load', function () {
  
     router.replace('/parkOver').catch((err: any) => {
       console.log(err);
     }) // 列表页面的路由
   
 });
new Vue({
  // @ts-ignore
  router,
  store,
  render: h => h(App)
}).$mount('#app')
